<template>
  <drag-drawer v-model="showDrawer"
               :width.sync="width"
               min-width="30px"
               :inner="true"
               :transfer="false"
               :placement="placementComputed"
               :draggable="true"
               @on-resize="handleResize"
               @on-close="handleClose"
               :scrollable="true">
    <div slot="header">
      <label> Test header</label>
    </div>
    <p>正在开发中。。。</p>
    <div slot="footer">

    </div>
  </drag-drawer>
</template>

<script>
    import DragDrawer from "./dragDrawer/drag-drawer";

    export default {
      name: "调试窗",
      components: {DragDrawer},
      props: ['test', 'flowId'],
      data() {
        return {
          width: 400,
          showDrawer:false,
          placement: 'right'
        }
      },
      methods: {
        handleResize(event) {
          const {atMin} = event
          console.log(atMin)
        },
        handleClose(val) {
          this.$emit('closeDrawer', true)
        }
      },
      computed: {
        placementComputed() {
          return this.placement ? 'left' : 'right'
        }
      },
      watch:{
        test:{
          deep:true,
          immediate:true,
          handler(val) {
            if (val) {
              this.showDrawer=true
            }
          }
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/flow/components/TestDrawer.vue